export const LOAD_ORDER_BUILDER_DATA = 'orderBuilder/LOAD_ORDER_BUILDER_DATA';
export const SET_ORDER_BUILDER_STATUS = 'orderBuilder/SET_ORDER_BUILDER_STATUS';
export const SET_ORDER_BUILDER_DATA = 'orderBuilder/SET_ORDER_BUILDER_DATA';

export const LOAD_CONFIGURATION_GROUP_DATA = 'orderBuilder/LOAD_CONFIGURATION_GROUP_DATA';
export const SET_CONFIGURATION_GROUP_STATUS = 'orderBuilder/SET_CONFIGURATION_GROUP_STATUS';
export const SET_CONFIGURATION_GROUP_DATA = 'orderBuilder/SET_CONFIGURATION_GROUP_DATA';
export const SET_CONFIGURATION_GROUP_LEFT = 'orderBuilder/SET_CONFIGURATION_GROUP_LEFT';
export const SET_CONFIGURATION_GROUP_RIGHT = 'orderBuilder/SET_CONFIGURATION_GROUP_RIGHT';

export const LOAD_CUSTOM_OPTIONS_GROUP_DATA = 'orderBuilder/LOAD_CUSTOM_OPTIONS_GROUP_DATA';
export const SET_CUSTOM_OPTIONS_GROUP_STATUS = 'orderBuilder/SET_CUSTOM_OPTIONS_GROUP_STATUS';
export const SET_CUSTOM_OPTIONS_GROUP_DATA = 'orderBuilder/SET_CUSTOM_OPTIONS_GROUP_DATA';
export const SET_CUSTOM_OPTIONS_GROUP_LEFT = 'orderBuilder/SET_CUSTOM_OPTIONS_GROUP_LEFT';
export const SET_CUSTOM_OPTIONS_GROUP_RIGHT = 'orderBuilder/SET_CUSTOM_OPTIONS_GROUP_RIGHT';

export const LOAD_ITEM_COMMENTS_DATA = 'storeHome/LOAD_ITEM_COMMENTS_DATA';
export const SET_ITEM_COMMENTS_STATUS = 'storeHome/SET_ITEM_COMMENTS_STATUS';
export const SET_ITEM_COMMENTS_DATA = 'storeHome/SET_ITEM_COMMENTS_DATA';

export const LOAD_CHECKBOX_SETTINGS_DATA = 'orderBuilder/LOAD_CHECKBOX_SETTINGS_DATA';
export const SET_CHECKBOX_SETTINGS_STATUS = 'orderBuilder/SET_CHECKBOX_SETTINGS_STATUS';
export const SET_CHECKBOX_SETTINGS_DATA = 'orderBuilder/SET_CHECKBOX_SETTINGS_DATA';

export const LOAD_DISCOUNT_SELECTION_SECTION_SETTINGS = 'orderBuilder/LOAD_DISCOUNT_SELECTION_SECTION_SETTINGS';
export const SET_DISCOUNT_SELECTION_SECTION_STATUS = 'orderBuilder/SET_DISCOUNT_SELECTION_SECTION_STATUS';
export const SET_DISCOUNT_SELECTION_SECTION_DATA = 'orderBuilder/SET_DISCOUNT_SELECTION_SECTION_DATA';

export const LOAD_PROMOTIONS = 'orderBuilder/LOAD_PROMOTIONS';
export const SET_PROMOTIONS_STATUS = 'orderBuilder/SET_PROMOTIONS_STATUS';
export const SET_PROMOTIONS_DATA = 'orderBuilder/SET_PROMOTIONS_DATA';

export const ADD_ORDER_TO_CART = 'cart/ADD_ORDER_TO_CART';
export const SET_CART_STATUS = 'cart/SET_CART_STATUS';
export const SET_CART_DATA = 'cart/SET_CART_DATA';

export const LOAD_PARENT_CODES_DATA = 'cart/LOAD_PARENT_CODES_DATA';
export const SET_PARENT_CODES_STATUS = 'cart/SET_PARENT_CODES_STATUS';
export const SET_PARENT_CODES_DATA = 'cart/SET_PARENT_CODES_DATA';

export const LOAD_PRESET_DATA = 'orderBuilder/LOAD_PRESET_DATA';
export const SET_PRESET_STATUS = 'orderBuilder/SET_PRESET_STATUS';
export const SET_PRESET_DATA = 'orderBuilder/SET_PRESET_DATA';
